module.exports = __webpack_public_path__ + "media/baby-growth.d512dde5.mp4";